import React from 'react'

// Helper function to create custom no options message component
// Export directly to avoid initialization order issues
export const cmbcCustomNoOptionsMessageComponentFunction =
  (autoFillStuffForNewPatientString, handleAddNewButtonClick) => (props) => {
    return (
      <div
        style={{
          margin: '4px',
          padding: '4px',
          background: '#E4F6D4',
          borderRadius: '8px',
          border: '1px solid green',
          cursor: 'pointer',
        }}
        onClick={() => {
          if (handleAddNewButtonClick) {
            handleAddNewButtonClick(autoFillStuffForNewPatientString)
          }
        }}
      >
        Create New Patient (with: {autoFillStuffForNewPatientString})
      </div>
    )
  }

// Custom reset/clear function component
export const cmbcCustomResetClearFuncComponent = (customClearFunction) => (props) => {
  console.log(props)
  return (
    <div
      style={{ cursor: 'pointer', color: 'blue', padding: '5px' }}
      onClick={() => {
        if (customClearFunction) {
          customClearFunction()
        }
      }}
    >
      Reset
    </div>
  )
}

